import React from 'react';
import './EventTitle.scss';

interface IProps {
  name: string;
  oneLiner: string;
}

const EventTitle: React.SFC<IProps> = ({
  name,
  oneLiner,
}) => (
  <div className='event-title'>
    <h1>{ name }</h1>
    <h2>{ oneLiner }</h2>
  </div>
);

export default EventTitle;


// WEBPACK FOOTER //
// ./src/pages/EventDetailPage/EventTitle/EventTitle.tsx